import { render, staticRenderFns } from "./TaskRuleComponent.vue?vue&type=template&id=5e79155f&"
import script from "./TaskRuleComponent.vue?vue&type=script&lang=js&"
export * from "./TaskRuleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports